/**
 * Represents a Block model with a code and a name.
 */
export class BlockModel {
    Block_Code: number =0;
    Block_Name: string ='';
    
}